(function ($) {
    $.fn.latestCardCarousel = function () {

        this.each((index, element) => {

            const $self = $(element);
            const $sliderContainer = $self.find('.slides-container');
            const $slider = $self.find('.splide');
            const $slideCount = $slider.find('.slide').length;
            const $arrowsContainer = $self.find('.arrows-container');

            // If slides not present
            if (!$slider[0]) {
                return;
            }


            // Calculate available space in right and set width and padding of slider accordingly
            let screenWidth = $('body').outerWidth();
            let titleContainer = $self.find('.module_title_container');
            let containerWidth = $(titleContainer).width();
            let widthAvailable = ((screenWidth - containerWidth) / 2) - 17.5;

            const sliderConfig = JSON.parse($self.attr('slider-config') || '{}');

            const sliderOptions = {
                direction: 'ltr',
                autoplay: false,
                pauseOnHover: true,
                pauseOnFocus: false,
                arrows: true,
                pagination: false,
                breakpoints: {
                    980: {
                        perPage: 3,
                    },
                    640: {
                        perPage: 2,
                    },
                    480: {
                        perPage: 1,
                    },
                },
                padding: { right: (widthAvailable - 35) + 'px' },
            };

            let slider;

            const sliderMobileBreakpoints = [
                'xs',
                'sm',
                'md',
            ];

            $self.currentBreakpoint = window.currentBreakpoint();

            // Set perPage for slider
            switch (true) {
                case (containerWidth > 980):
                    sliderOptions.perPage = 4;
                    break;
                case (containerWidth <= 980 && containerWidth > 800):
                    sliderOptions.perPage = 3;
                    break;
                case (containerWidth <= 800 && containerWidth > 480):
                    sliderOptions.perPage = 2;
                    break;
                case (containerWidth <= 480):
                    sliderOptions.perPage = 1;
                    break;
            }

            if ($slideCount === 3 && containerWidth > 980) {
                sliderOptions.perPage = 3;
            }

            console.log(sliderOptions.perPage + ':' + containerWidth);



            function isMobile() {
                return sliderMobileBreakpoints.includes($self.currentBreakpoint);
            }

            function getSliderOptions() {
                return { ...sliderConfig, ...sliderOptions };
            }

            function initSlider() {
                $slider.sliderType = isMobile() ? 'mobile' : 'desktop';
                screenWidth = $('body').outerWidth();
                containerWidth = $self.find('.module_title_container').width();
                widthAvailable = ((screenWidth - containerWidth) / 2) - 10;

                // Check for left right overflow slides
                if (!$($slider[0]).parents('.single-program').length &&
                    !$($slider[0]).parents('.single-workstream').length) {
                    
                    $sliderContainer.addClass('full-width');
                    $($slider[0]).addClass('full-width');
                    //sliderOptions.padding = {right: (widthAvailable - 35) + 'px'};
                    sliderOptions.padding = { right: widthAvailable + 'px', left: widthAvailable + 'px' };
                    //$slider.css('width', (containerWidth + widthAvailable) + 'px');
                }
                else{
                    $slider.css('width', (containerWidth + 35) + 'px');
                    sliderOptions.padding = { right: '0px', left: '0px' };
                }

                slider = new window.Splide($slider[0], getSliderOptions());

                // On slider arrows:updated
                slider.on('arrows:updated', function () {
                    setArrowDisable();
                });

                slider.mount();
            }

            // For custom arrows clicks
            $arrowsContainer.find('.splide__arrow--prev').on('click', () => {
                $slider.find('.splide__arrows .splide__arrow--prev').trigger('click');
            });

            $arrowsContainer.find('.splide__arrow--next').on('click', () => {
                $slider.find('.splide__arrows .splide__arrow--next').trigger('click');
            });

            // Function to set arrow disable
            function setArrowDisable() {

                // Disable/Enable previous arrow
                if ($slider.find('.splide__arrows .splide__arrow--prev').attr('disabled') !== undefined) {
                    $arrowsContainer.find('.splide__arrow--prev').attr('disabled', 'disabled');
                }
                else {
                    $arrowsContainer.find('.splide__arrow--prev').removeAttr('disabled');
                }

                // Disable/Enable Next arrow
                if ($slider.find('.splide__arrows .splide__arrow--next').attr('disabled') !== undefined) {
                    $arrowsContainer.find('.splide__arrow--next').attr('disabled', 'disabled');
                }
                else {
                    $arrowsContainer.find('.splide__arrow--next').removeAttr('disabled');
                }
            }

            // On window resize
            $(window).on('resize', () => {
                update();
                slider.destroy();
                initSlider();
            });



            function update() {
                /** Update currentBreakpoint */
                $self.currentBreakpoint = window.currentBreakpoint();
            }

            initSlider();
        });


        return this;
    }

    $(() => {
        $('.module.latest_card_carousel').latestCardCarousel();
    })

})($);




// WEBPACK FOOTER //
// ./scripts/modules/blocks/latest-card-carousel.js